(function ($, Drupal) {
  'use strict';

  if ('objectFit' in document.documentElement.style === false) {
    Drupal.behaviors.frontendObjectFit = {
      attach: function (context) {
        $('picture img', context)
          .each(updateBackgroundImage)
          .on('load', updateBackgroundImage)
          .css('opacity', 0);
      }
    };
  }

  function updateBackgroundImage() {
    if (this.complete) {
      $(this).closest('picture').css('background-image', 'url(' + (this.currentSrc || this.src) + ')');
    }
  }

})(jQuery, Drupal);
